import React from "react";
import { observer } from "mobx-react";
import gamingStore from "../stores/quizStore";

@observer
class Quiz extends React.Component {
  render() {
    let { currentQuestion, currentAnswer, ready } = gamingStore;
    if (!ready) return <div>Cargando Cuestionario...</div>;
    return (
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <div className="row border-top pt-4">
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
            <h4>{currentQuestion.description}</h4>
            <h3>{currentQuestion.title}</h3>
          </div>
          <div className="col-xl-8 col-lg-8 col-md-6 col-sm-12 col-12">
            <form className="quiz">
              <div className="list-group">
                {currentQuestion.answers.map((a) => (
                  <label
                    key={a.id}
                    className={
                      "list-group-item" +
                      (currentAnswer === a.id
                        ? " list-group-item-selected"
                        : "")
                    }
                    onClick={() => gamingStore.setCurrentAnswer(a.id)}
                  >
                    {a.description}
                  </label>
                ))}
              </div>
              {currentAnswer && (
                <button
                  className="btn2 mt-3 btn-continue"
                  onClick={(e) => {
                    e.preventDefault();
                    gamingStore.submitAnswer(currentQuestion.id, currentAnswer);
                  }}
                >
                  SIGUIENTE <i className="fas fa-chevron-right"></i>
                </button>
              )}
            </form>
          </div>
        </div>
      </div>
    );
  }
}
export default Quiz;
